module.exports = __webpack_public_path__ + "static/media/personal-fire.ea839c79.png";